import { render } from "./Translation.vue?vue&type=template&id=c45f2b94&scoped=true"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"

import "../style/TagsViewStyle.css?vue&type=style&index=0&id=c45f2b94&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45f2b94"]])

export default __exports__